module.exports = __webpack_public_path__ + "static/media/nine-ball.a3dd795a.png";